module.exports = __webpack_public_path__ + "static/media/38-10.c44d1038.mp3";